/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Tooltip,
  Box
} from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import ClientProjectSelect from "components/ClientProjectSelect";

import "react-datepicker/dist/react-datepicker.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "rsuite/dist/rsuite.min.css";
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from "@chakra-ui/styled-system";

import CurrencyFormat from 'react-currency-format';
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";

import calculateTds from "jsFunctions/calculateTds";
import PaymentInfoComponent from "../paymentInfoComponent";
import { fetchAsyncGetPONumTDSExpense,fetchAsyncResourcePONum,fetchAsyncDeleteTdsPdf ,fetchAsyncUploadTdsPdf,fetchAsyncUpdateTdsExpense, fetchAsyncAddTDSInvoiceRemark, fetchAsyncGetByReferencePoDetails, fetchAsyncSendRequestUpdateApprovalTdsTotalPayAmount, fetchAsyncSendRequestApprovalTdsTotalPayAmount, fetchAsyncApproveTdsTotalPayAmount, fetchAsyncRejectTdsTotalPayAmount, fetchAsyncDeleteTdsPaymentListItem, fetchAsyncDeleteTdsRefundListItem} from "redux/tdsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { useToasts } from "react-toast-notifications";

import moment from "moment";
import { tdsFormValidation } from "validation";

import { checkApprovalAmount,checkTotalApprovedAmountWithSpentAmount,poNumberFormate } from "jsFunctions/helperFunctions";

import { InputGroup, Tab, Tabs } from "react-bootstrap";
import RefundInfoListComponent from "../refundListInfoComponent";
import { fetchAsyncGetVendor,fetchAsyncGetVendorByID,fetchAsyncGetTotalPayAmountByPanNumber } from "redux/vendorSlice";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import QuotationForm from "../seprateFormComponent/quatationForm";
import { FaCheck, FaFileUpload, FaPlusCircle } from "react-icons/fa";
import { fetchAsyncGetAllQuotation } from "redux/quotationSlice";
import PanNumberField from "../seprateFormComponent/panNumberField";
import DownloadExcelFile from "../DownloadExcel/downloadExcel";
import TdsDataChangeModal from "components/models/DataChange/tdsDataChangeModal";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { spentAmountValidate } from "validation/spentAmount";
import { refundAmountValidate } from "validation/refundAmount";
import AmountPopover from "../amountPopover/addAmountPopover";
import prJson from "components/jsonData/purchase.json";
import commonJson from "components/jsonData/common.json";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { RiFileDownloadLine } from "react-icons/ri";
import InvoiceComponent from "../seprateFormComponent/InvoiceComponent";
import { sumOfPaymentRecordAmount,sumOfRefundAmount } from "utiils/halper";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const xl = defineStyle({
  px: "6",
  py: "2",
  fontSize: "xl",
});

const sm = defineStyle({
  fontSize: "sm",
  py: "6",
});

const sizes = {
  xl: definePartsStyle({ header: sm, dialog: xl }),
};

export const modalTheme = defineMultiStyleConfig({
  sizes,
});

const TdsAddNew = ({
  tdsOpen,
  tdsClose,
  tdsExpenseData,
  isEditForm = false,
  editItem, 
  refreshEditData,
  activeList,
  role
}) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const formOptionsList1 = useSelector((state) => state.formOptions);

  const dateRange = useSelector((state) => state.dateRange); 
  const { startDate } = dateRange;

  const [isEdit, setIsEdit] = useState(isEditForm)
  const [editData, setEditData] = useState(editItem)
  const [poPrefix, setPoPrefix] = useState({
    prfx: "PR-T-",
    m: new Date().getMonth() + 1,
    y: new Date().getFullYear(),
    n: 1,
  });
  const [getPoMonth, setGetPoMonth] = useState("");

  const [generatedNum, setGeneratedNum] = useState("PR-T-");
  const [isTds, setIsTds] = useState(false);
  const [isBlink, setIsBlink] = useState(false)
  const [activeTab, setActiveTab] = useState('')
  const [formOptionsList, setFormOptionsList] = useState([])

  const [amountTotal, setAmountTotal] = useState("");
  const [tdsAmount, setTdsAmount] = useState("");
  const [resourceOption, setResourceOption] = useState([]);
  const [editTDSAmount, setEditTDSAmount] = useState(true);
  const [tdsPercent, setTdsPercent] = useState("");

  const [editPercentNum, setEditPercentNum] = useState(true);
  const [setResourcePoNo, setSetResourcePoNo] = useState("");
  const [isResourcePoChange, setIsResourcePoChange] = useState(false);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [multipleInvoiceData, setMultipleInvoiceData] = useState([]);
  const [billNumber, setBillNumber] = useState("");

  const [multipleAddPaymentInfo, setMultipleAddPaymentInfo] = useState([]);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
  const [approvalAmount, setApprovalAmount] = useState(null);
  const [roundOfAmount, setRoundOfAmount] = useState("");
  const [paymentStatus, setPaymentStatus] = useState(0);

  const [remarksValue, setRemarksValue] = useState('');
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [spentAmountError, setSpentAmountError] = useState([{}]);
  const [refundAmountError, setRefundAmountError] = useState([{}]);
  const [isRefund, setIsRefund] = useState(false);
  const [comparingData, setComparingData] = useState(null);
  const [approveOrRejectRemarks, setApproveOrRejectRemarks] = useState('')

  const [poNoResource, setPoNoResource] = useState([]);
  const [resourceValue, setResourceValue] = useState("");
  const [compareDataModal, setCompareDataModal] = useState(false);

  const [totalPayAmountByPanNumber, setTotalAmountByPanNumber] = useState({})
  const [multipleAddRefundInfo, setMultipleAddRefundInfo] = useState([""]);
  const vendorList = useSelector((state) => state.vendorData);
  const [openQuotation, setOpenQuotation] = useState(false)

  const [panNumber, setPanNumber] = useState("");
  const [quotationData, setQuotationData] = useState({
    remarks:"",
    amount:"",
    files:""
  })

  const [allQuotation,setAllQuotation] = useState([])

  const resetAllStateOnCloseModal = () => {
    setTdsPercent(10);
    setIsTds(false);
    setEditTDSAmount(true);
    setEditPercentNum(true);
  };
  useEffect(
    () => {
      if( amountTotal && tdsPercent ){
        setTdsAmount(calculateTds(amountTotal, tdsPercent));
      }
      else{
        setTdsAmount(0)
      }
    },
    [amountTotal],
    [tdsPercent]
  );


  const totalSpentAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
      if (multipleAddPaymentInfo.length > 0) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        const totalRefund = sumOfRefundAmount(multipleAddRefundInfo || [])

        return parseFloat(total) - parseFloat(totalRefund); 
      }
    }
    return 0;
  }, [multipleAddPaymentInfo,multipleAddRefundInfo]);

  const remainingAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        return parseFloat(totalPaymentAmount) -  parseFloat(total); 
    }
    return 0;
  }, [multipleAddPaymentInfo,totalPaymentAmount]);

  useEffect(()=>{
    if(formOptionsList1 && formOptionsList1?.length > 0){
      const internalFormOptionList = formOptionsList1.filter((item)=> item.expTyp === 'tds')
      setFormOptionsList(internalFormOptionList)
    }
  },[formOptionsList1])

  useEffect(() => {
    dispatch(fetchAsyncResourcePONum()).then((res) => {
      if (res.payload) {
        const array = res.payload.map((item) => {
          item.poNo = poNumberFormate(item?.poNo)
          return item;
        })
        const resourcePoNo = clientProjectOptions('poNo','_id',array) 
        const value = resourcePoNo && resourcePoNo?.length > 0 && resourcePoNo.find((item)=> item.value === editData?.rfPo)
        setPoNoResource(resourcePoNo);
        setSetResourcePoNo(value);

      }
    });
    dispatch(fetchAsyncGetVendor());

  
    if(!isEdit){
      setTimeout(() => {
        setIsBlink(true)
      }, 3000); 
      setTimeout(() => {
        setIsBlink(false);
      }, 4000); 
    }
  }, []);

  const closeComparedDataModal = () => {
    setCompareDataModal(false);

    setComparingData(null);
  };
  const submitUpdateData = (formData, editData) => {
    setIsLoading(true)
    dispatch(
      fetchAsyncUpdateTdsExpense({
        id: editData._id,
        data: formData,
      })
    )
      .then((res) => {
        if (res.payload) {
          const msg = prJson.confirm.updatePurchase.replace("{generatedNum}", generatedNum);
          addToast(msg, { appearance: "success" });
          setIsLoading(false)

      }
        tdsClose('approved');
        setComparingData(null);
        formik.resetForm();
      })
      .catch((error) => {
        setIsLoading(false)
        addToast("Error", { appearance: "error" });
      });
  };

  const startOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const endOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0); 
useEffect(()=>{
  if(startDate && !isEdit){
    const formattedMonth = moment(startDate).format("YYYY-MM");
    setGetPoMonth(formattedMonth);
  }
  else{
    setGetPoMonth(moment().format("yyyy-MM"))
  }
  
},[startDate])

useEffect(()=>{
  if(getPoMonth && !isEdit){
    const formattedMonth = moment(getPoMonth).format("YYYY-MM");
    setGetPoMonth(formattedMonth);
    if (moment(formattedMonth).isSame(moment(), 'month')) {
      const creditDate = moment().toDate(); 
      setSelectedDate(creditDate); 
    }
    else{

      const firstDayOfMonth = moment(formattedMonth).startOf('month').toDate();
      setSelectedDate(firstDayOfMonth);
    }
  }
  
},[getPoMonth])

  const initialValues = {
    poNo: "",
    orderMonth: "",
    orderDate: "",
    resourceName: "",
    remarks: "",

    payee: 0,
    paymentAmount: 0,
    bank: "",
    referance: "",
    date: null,
   
   
    approvalAmount: 0,
    isTDS: false,
    totalAmount: 0,
    tdsPercent: 0,
    totalTDS: 0,

    isTDSPO: false,
    TDSPONum: "",
    source: "",
    invoiceNum: "",
    invoiceDate: null,
    reimbursmentAmount: 0,
   
    invoice: "",
  };

  const getFormData = (values)=>{
    let formData = new FormData();
    formData.append("poNo", JSON.stringify(poPrefix));
    formData.append("orderMonth", getPoMonth);
    formData.append("orderDate", selectedDate);
    formData.append("resourceId", resourceValue.value || "");
    formData.append("roundOfAmount", roundOfAmount);
    formData.append("billNumber", billNumber);
    formData.append("resourceName", resourceValue.label || "");

    formData.append("panNumber", panNumber);
    formData.append("remarks", remarksValue);
    formData.append("refResourcePONum", setResourcePoNo?.value);
    formData.append("totalPaymentAmount", totalPaymentAmount);
    formData.append("approvalAmount", approvalAmount);

    formData.append("isTDS", isTds);

    formData.append("totalAmount", amountTotal);
    formData.append("tdsPercent", tdsPercent);
    formData.append("tdsAmount", tdsAmount);
    formData.append("invoiceNum", values.invoiceNum);
    formData.append("isRefund", isRefund);
    formData.append("approveRejectRemarks", approveOrRejectRemarks);

    const filteredMultipleAddRefundInfoPay = multipleAddRefundInfo.filter(
      (item) => item?.amt
    );

    formData.append(
      "refundInfo",
      JSON.stringify(filteredMultipleAddRefundInfoPay)
    );

    if (
      quotationData &&
      (quotationData?.files?.length > 0 || quotationData?.remarks)
    ) {
      formData.append("quotation_remarks", quotationData?.remarks);
      formData.append("quotation_amount", quotationData?.amount);
      Array.from(quotationData?.files).forEach((file) => {
        formData.append("quotation_files", file);
      });
    }
    const filteredInvoice = multipleInvoiceData?.filter((item) => item?.file);
    formData.append("invoiceData", JSON.stringify(filteredInvoice));
    filteredInvoice.forEach((inv, idx) => {
      formData.append(`invoiceFiles[${idx}]`, inv.file);
    });
    return formData;
  }
const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: tdsFormValidation,
    onSubmit: (values, { resetForm }) => {
      if (!resourceValue) {
        setErrors({
          ...errors,
          resourceValue:prJson.required.resourceName
        })
        return;
      }
     
      const spentError = spentAmountValidate(
        multipleAddPaymentInfo,remainingAmount
      );
      if (Object.keys(spentError).length !== 0) {
        setSpentAmountError(spentError)
        if(activeTab && activeTab !== 'spent'){
          addToast(prJson.error.checkSpent, { appearance: "error" });
        }
        return;
      }
      if(isRefund){
        const refundError = refundAmountValidate(
          multipleAddRefundInfo,remainingAmount
        );
        if (Object.keys(refundError).length !== 0) {
          setRefundAmountError(refundError)
          if(activeTab !== 'refund'){
            addToast(prJson.error.checkRefund, { appearance: "error" });
          }
          return;
        }
      }
      const checkApproval = checkApprovalAmount(
        approvalAmount,
      );
      if (!checkApproval.status) {
        setErrors({
          ...errors,
          approvalAmount:checkApproval.msg
        }) 
        return;
      }
      const filteredMultipleAddPaymentInfo = multipleAddPaymentInfo.filter((item) => item?.amt);
      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        filteredMultipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })
        return;
      }
      
      let formData = getFormData(values);

      const filteredMultipleAddPaymentInfoPay = filteredMultipleAddPaymentInfo.map((item)=>{
        if(item?.inv){
          return {
            ...item,
            inv: item?.inv.filter(entry => 'Key' in entry)
          }
        }
        else{
          return item
        }
      });
      formData.append("payInfo", JSON.stringify(filteredMultipleAddPaymentInfoPay));
      
      if (isEdit) {
        setComparingData(formData);
      }
    },
  });
  const handleEditTDSPercentange = () => {
    setEditPercentNum(false);
  };
  const handleEditSubmit = () => {
    setEditTDSAmount(true);
  };
  const handleEditTDS = () => {
    setEditTDSAmount(false);
  };
 

  // SET PO NUMBER

  useEffect(() => {
    setGeneratedNum(poNumberFormate(poPrefix));
  }, [poPrefix]);

  const handelDeleteInvoice = (index) => {
    if(multipleInvoiceData){
      let invoices = multipleInvoiceData.filter((item, i) => i !== index)
      setMultipleInvoiceData(invoices);
    }
  };
  useEffect(() => {
    if (!isEdit && getPoMonth) {
      const dataSplit = getPoMonth.split("-");
      dispatch(
        fetchAsyncGetPONumTDSExpense({
          month: dataSplit[1],
          year: dataSplit[0],
        })
      )
        .then((res) => {
          if (res.payload?.[0]?.poNo) {
            setPoPrefix((prev) => {
              return {
                prfx: prev.prfx,
                m: dataSplit[1],
                y: dataSplit[0],
                n: res.payload?.[0]?.poNo.n + 1,
              };
            });
          } else {
            setPoPrefix((prev) => {
              return {
                prfx: prev.prfx,
                m: dataSplit[1],
                y: dataSplit[0],
                n: 1,
              };
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getPoMonth]);

  const finalRef = useRef(null);

  // create option
  const handleInvoiceChange = () => {
    if(multipleInvoiceData){
      if (multipleInvoiceData?.length < 5) {
       setMultipleInvoiceData([
         ...multipleInvoiceData,
         {
           spId:"",
           Key:"",
           remark:"",
           file:""
         },
       ])
    }
   }
  };
  useEffect(() => {
    setTdsAmount(calculateTds(amountTotal, tdsPercent));
  }, [amountTotal, tdsPercent]);

  const handleUpdateInvoiceData = (invoiceData, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].file = invoiceData;
    setMultipleInvoiceData(newData);
  };
  const handleAddInvoiceRemarks = (value, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].remark = value
    setMultipleInvoiceData(newData);
  };
  // payment info function
  const handleMultiplePayInfo = (data) => {
    setMultipleAddPaymentInfo([
      ...multipleAddPaymentInfo,
      {
        amt:remainingAmount,
        pmtDt:new Date()
      },
    ]);
  };
  const handleUpdateMultiplePayData = (payData, index) => {
    const updateList = multipleAddPaymentInfo.map((item, i) => {
      if (i === index) {
        return {...item,...payData};
      } else return item;
    });
    const sum = updateList.reduce((acc, current) => {
      if (current?.amt && current?.amt !== '') {
        return acc + parseFloat(current?.amt);
      } else {
        return acc;
      }
    }, 0);  

    const remaning = parseFloat(totalPaymentAmount) - parseFloat(sum)
    const spentError = spentAmountValidate(
      updateList,
      remaning
    );
    if (spentError) {
      setSpentAmountError(spentError)
    }
    setMultipleAddPaymentInfo([...updateList]);
  };

  
  const handleDeleteInvoiceOnEdit = (key,spId) => {
    ConfirmationDialog({
      title: prJson.confirm.invoice,
      text: `Delete File ${key}`,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true)

        const sendData = {
          id: editData._id,
          key: key,
          spId: spId || ""
        };
        dispatch(fetchAsyncDeleteTdsPdf(sendData)).then((res) => {
          if(res?.payload?.tdsExpense?.pyInfo?.list){
            setMultipleAddPaymentInfo(res?.payload?.tdsExpense?.payInfo?.list)
            refreshEditData();
            addToast(prJson.success.deletedInvoice, { appearance: "success" });
            setIsLoading(false)
          }
          else{
            setIsLoading(false)
            addToast(prJson.error.generic, { appearance: "error" });
          }

        }).catch((error) => {
          addToast(prJson.error.generic, { appearance: "error" });
          setIsLoading(false);
      });
      },
    });
  };

  const getAllCompanyOptions = async()=>{
      const companyOption = await clientProjectOptions('name','_id',vendorList) 
      setResourceOption(companyOption);
  }

  useEffect(()=>{
    if(vendorList){
      getAllCompanyOptions()
    }
  },[vendorList])


const getTotalPayAmount = async(panNo)=>{
  await dispatch(fetchAsyncGetTotalPayAmountByPanNumber(panNo)).then((res)=>{

    if(res?.payload){
    setTotalAmountByPanNumber(res?.payload)
      
    }
    }).catch((err)=>{
      setTotalAmountByPanNumber({})

      console.log(err)
    })
}
useEffect(()=>{
  if(panNumber){
    getTotalPayAmount(panNumber)
  }
},[panNumber])
const isValidObjectId = (id) => {
    return /^[a-f0-9]{24}$/.test(id);
};

  useEffect(() => {
    if(resourceValue && resourceValue?.value){
      const id = resourceValue?.value;
      if(isValidObjectId(id)){

        dispatch(fetchAsyncGetVendorByID(id)).then((res)=>{
  
          if(res?.payload){
            const {pnNo} = res?.payload?.vendor;  
            setPanNumber(pnNo)
          }
          }).catch((err)=>{
            console.log(err)
          })
      }
      }
  }, [resourceValue]);



  const addNewInvoiceOnEdit = (file, index) => {
    ConfirmationDialog({
      title: prJson.confirm.uploade,
      text: `Upload - ${file.name}`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        setIsLoading(true)

        if (editData) {
          
          let formData = new FormData();
          const getPoNoById = (id) => {
            const result = poNoResource.find(item => item._id === id);
            return result ? result.poNo : undefined;
          };

          const referenceResourcePO = getPoNoById('');
  
          formData.append("poNo", JSON.stringify(editData.poNo));
          formData.append("file", file);
          formData.append("index", index);
          formData.append("referenceResourcePO", JSON.stringify(referenceResourcePO || ''));

          dispatch(fetchAsyncUploadTdsPdf({ id: editData._id, formData })).then(
            (res) => {
              if(res?.payload && res?.payload?.tdsExpense?.pyInfo?.inv){

                setMultipleInvoiceData(res?.payload?.tdsExpense?.pyInfo?.inv)
              refreshEditData();
              setIsLoading(false)
              addToast(prJson.success.uploaded, { appearance: "success" });
            }
            else{
              setIsLoading(false);
              addToast(prJson.error.generic, { appearance: "error" });

            }
          }).catch((error) => {
            addToast(prJson.error.generic, { appearance: "error" });
            setIsLoading(false);
        });
        }
      }
    });
  };
  const getCompanyByID = async(id)=>{
    await dispatch(fetchAsyncGetVendorByID(id)).then((res)=>{

    if(res?.payload){
      const vendor = res?.payload?.vendor;
      const setData = {
        label: vendor.name,
        value: vendor?._id,
      };
            
      setResourceValue(setData);
      setPanNumber(vendor?.pnNo)
    }
    }).catch((err)=>{
      console.log(err)
    })
  }

  const getReferencePoDetails = async(id)=>{
   
    dispatch(fetchAsyncGetByReferencePoDetails(id)).then((res)=>{
      if(res?.payload){
        const referenceExpense = res?.payload?.referenceExpense;
        if (res?.payload && referenceExpense) {
          if(referenceExpense?.resourceId){
            getCompanyByID(referenceExpense?.resourceId)
          }
          if(isResourcePoChange){

            if(referenceExpense?.tds && referenceExpense?.tdsApl?.sts){
              const tdsData = referenceExpense?.tdsApl;
              setAmountTotal(tdsData?.bsAmt)
              setTdsPercent(tdsData?.prc)
              setTdsAmount(tdsData?.tlAmt)
              if(!editData?.payInfo?.apAmt){
                setApprovalAmount(tdsData?.tlAmt + roundOfAmount)
              }
            }
            else if(referenceExpense?.pyInfo?.apAmt){
              setAmountTotal(referenceExpense?.pyInfo?.apAmt)
              if(!editData?.pyInfo?.apAmt){
                setApprovalAmount(referenceExpense?.pyInfo?.apAmt + roundOfAmount)
              }
            }
          }
          else{
            if(referenceExpense?.tdsApl && referenceExpense?.tdsApl?.sts){
              const tdsData = referenceExpense?.tdsApl;
              setAmountTotal(editData?.tlBlAmt ? editData?.tlBlAmt : tdsData?.bsAmt)
              setTdsPercent(editData?.prc ?editData?.prc :tdsData?.prc)
              setTdsAmount(editData?.tdsAmount ? editData?.tdsAmount :tdsData?.bsAmt)
              if(!editData?.pyInfo?.apAmt){
                setApprovalAmount(tdsData?.tlAmt + roundOfAmount)
              }
            }
            else if(referenceExpense?.pyInfo?.apAmt){
              setAmountTotal(editData?.tlBlAmt ? editData?.tlBlAmt  :referenceExpense?.pyInfo?.apAmt)
              if(!editData?.pyInfo?.apAmt){
                setApprovalAmount(referenceExpense?.pyInfo?.apAmt + roundOfAmount)
              }
            }
          }
        }
        }
      }
    ).catch((err)=>{
      console.log(err)
    })
  }

  useEffect(()=>{
    if(setResourcePoNo && setResourcePoNo?.val){
      getReferencePoDetails(setResourcePoNo?.val);
    }
  },[setResourcePoNo])
  // Changes on Edit
 
  const handleQuotationData = (data)=>{
    setQuotationData(data)
  }

  const handleCloseQuotation = ()=>{
    setOpenQuotation(!openQuotation)
    if (isEdit && editData) {
    getAllQuotation(editData?._id)
    }
  }
  const getAllQuotation = async(_id)=>{
    await dispatch(fetchAsyncGetAllQuotation(_id)).then((res)=>{

        if(res?.payload){
            const quotations = res.payload?.quotations;
            setAllQuotation(quotations)
        }
        }).catch((err)=>{
          console.log(err)
        })
}
  
  useEffect(() => {
    // fill data in form on edit
    if (isEdit && editData) {
      getAllQuotation(editData?._id)

      setPoPrefix(editData.poNo);
      setSelectedDate(new Date(editData.oDt));

      setGetPoMonth(
        `${editData.poNo.y}-${
          editData.poNo.m <= 9
            ? "0" + editData.poNo.m
            : editData.poNo.m
        }`
      );
     
      if(editData?.resId && editData?.resId?._id){
        getCompanyByID(editData?.resId?._id)
      }
     
        setPanNumber(editData?.pnNo)
      
        if (editData?.pyInfo?.blNo) {
          setBillNumber(editData?.pyInfo?.blNo || "")
        }
        else if(editData.pyInfo?.list && editData.pyInfo?.list?.length > 0) {
          setBillNumber(editData.pyInfo?.list[0]?.blNo || "");
        }
      if (editData.pyInfo?.tlAmt) {
        setTotalPaymentAmount(editData.pyInfo?.tlAmt);
      }
      if (editData.pyInfo?.sts) {
        setPaymentStatus(editData.pyInfo?.sts)
      }
      

     
      if (editData.pyInfo?.apAmt) {
        setApprovalAmount(editData.pyInfo?.apAmt);
      }
      if(editData.pyInfo?.inv && editData.pyInfo?.inv?.length > 0) {
        setMultipleInvoiceData(editData.pyInfo?.inv);
      }
      if (editData.pyInfo?.list && editData.pyInfo?.list.length > 0) {
        setMultipleAddPaymentInfo(editData.pyInfo?.list);
      }
      if (editData?.acRmks) {
        setApproveOrRejectRemarks(editData?.acRmks)
      }
      if (editData?.roAmt) {
        setRoundOfAmount(editData?.roAmt)
      }
     
      if (editData?.tlBlAmt) {
        setAmountTotal(editData?.tlBlAmt);
      }
      if (editData?.rmks) {
        setRemarksValue(editData?.rmks)
      }
      if (editData.rfdInfo?.list && editData.rfdInfo?.list.length > 0) {
        setMultipleAddRefundInfo(editData.rfdInfo?.list);
      }
      if (editData?.rfdInfo && editData?.rfdInfo?.sts) {
        setIsRefund(editData?.rfdInfo?.sts);
      }
      if (editData?.prc) {
        setTdsPercent(editData?.prc);
      }
      if (!editData?.prc && editData?.tdsAmt) {
        const prc = ((editData?.tdsAmt / editData?.tlBlAmt) * 100).toFixed(2)
        setTdsPercent(prc);
      }
      if (editData?.tdsAmt) {
        setTdsAmount(editData?.tdsAmt);
      }
    }
  }, [isEdit, editData]);

  // add Remark for Invoice
  const addRemarkForInvoice = (value,index) => {
    dispatch(
      fetchAsyncAddTDSInvoiceRemark({
        id: editData._id,
        remarkData: { remark: value, index },
      })
    ).then((res) => {
      setMultipleAddPaymentInfo(res?.payload?.tdsExpense?.pyInfo?.inv)

      refreshEditData();
    });
  };

  const handleAmountApproveBtn = (values)=>{   
  
      if (!resourceValue) {
        setErrors({
          ...errors,
          resourceValue:prJson.required.resourceName
        })        
        return;
      }
     

    const checkApproval = checkApprovalAmount(
      approvalAmount,
    );
    if (!checkApproval.status) {
      setErrors({
        ...errors,
        approvalAmount:checkApproval.msg
      }) 
      return;
    }
  
    if(approvalAmount <= totalPaymentAmount && remainingAmount >= 0){
  
      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        multipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })
        return;
      }
    }
    if(remainingAmount < 0 && approvalAmount <= totalPaymentAmount){
      return;
    }
    let formData = getFormData(values);
      
      if(isEdit && editData){
        setIsLoading(true)
        if(isRequestedAmountMismatch){
          if(multipleAddPaymentInfo?.length && approvalAmount < totalPaymentAmount){
            addToast(prJson.error.spentAmt,{ appearance: "info" });
            setIsLoading(false)
          }
         else{
        dispatch(fetchAsyncSendRequestUpdateApprovalTdsTotalPayAmount
          ({ 
          id: editData._id,
          data:formData
         })).then(
          (res) => {
            if (res.payload && res.payload.updatedData) {
              const msg = prJson.confirm.resendRequest.replace("{generatedNum}", generatedNum);

              setIsEdit(true)
              setEditData(res.payload.updatedData)
              setPaymentStatus(0)
              addToast(msg, { appearance: "success" });
              tdsClose('pending');
              setIsLoading(false)
            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
         }
        }
      }
      else{
        setIsLoading(true)

        dispatch(fetchAsyncSendRequestApprovalTdsTotalPayAmount(formData)).then((res) => {
            if (res.payload) {
              const msg = prJson.confirm.sendRequest.replace("{generatedNum}", generatedNum);
              addToast(msg, { appearance: "success" });
              setIsEdit(true)
              setEditData(res.payload)
              setPaymentStatus(0)
              tdsClose('pending');
              setIsLoading(false)

            
            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
      }
      
      
      }

      const handleMultipleRefundInfo = (data) => {
        setMultipleAddRefundInfo([
          ...multipleAddRefundInfo,
          { data: "", paydata: data.data },
        ]);
      };

  const handleUpdateMultipleRefundData = (payData, index) => {
    const updateList = multipleAddRefundInfo.map((item, i) => {
      if (i === index) {
        return { ...item, ...payData };
      } else return item;
    });
    const refundError = refundAmountValidate(
      updateList,
      remainingAmount
    );
    if (refundError) {
      setRefundAmountError(refundError)
    }
    setMultipleAddRefundInfo([...updateList]);
  };
  useEffect(()=>{
    setApprovalAmount(Number(tdsAmount || 0) + Number(roundOfAmount || 0))
  },[tdsAmount,roundOfAmount])

  useEffect(()=>{
    setTotalPaymentAmount(Number(approvalAmount))
  },[approvalAmount])

  const handleTotalPayAmountIsApproved = (values)=>{
    const _id = editData._id;
   
    let formData = getFormData(values);

  
    if(editData.pyInfo?.sts === 0){
      const confirmMsg = prJson.confirm.approveAmt;
      const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.approveAction,  
        icon: "warning",
        confirmButtonText: "Approve",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          setIsLoading(true)
          dispatch(fetchAsyncApproveTdsTotalPayAmount({ 
            id: _id,
            data:formData
           })).then(
            (res) => {
              if (res.payload && res.payload.updatedData ) {
                const msg = prJson.success.approved.replace("{generatedNum}", generatedNum);
                addToast(msg, { appearance: "success" });
                setIsLoading(false)
                tdsClose('approved');
              }
            }
          );
        }
      })
    }
  }

  const handleTotalPayAmountIsRejected = ()=>{
    const _id = editData._id;
   
    if(editData.pyInfo?.sts === 0 ){
      const confirmMsg = prJson.confirm.rejectAmt;
      const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.rejectAction,
        icon: 'warning',
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          setIsLoading(true)
          dispatch(fetchAsyncRejectTdsTotalPayAmount({ 
            id: _id,
            data:{approveRejectRemarks:approveOrRejectRemarks}
           })).then(
            (res) => {
              if (res.payload && res.payload.updatedData) {
                const msg = prJson.success.rejected.replace("{generatedNum}", generatedNum);
                addToast(msg, { appearance: "success" });
                tdsClose('rejected');
                setIsLoading(false)
              }
            }
          );
        },
      });
    }
  
  }


  useEffect(()=>{
    if(totalPaymentAmount){
      if(totalPaymentAmount && !editData?.tdsApl?.tlAmt && isTds){
        setAmountTotal(parseFloat(totalPaymentAmount))
      }
    }
  },[totalPaymentAmount])

  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: 'warning',
      confirmButtonText: 'Close',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        tdsClose();
        resetAllStateOnCloseModal();
      },
    });
  };

  const handleRemarksChange = (e)=>{
    const value = e?.target?.value;
    const encoder = new TextEncoder(); // Default is 'utf-8'
    const byteLength = encoder.encode(value).length;
    if(byteLength <=128){

      setRemarksValue(value)
      setErrors({
        ...errors,
        remarks:''
      })
    }
    else{
      setErrors({
        ...errors,
        remarks:prJson.error.remarksLimit
      })
    }
  }

 
  const deleteMultipleListItem = (listIndex)=>{
    ConfirmationDialog({
      title: prJson.confirm.deleteAmt,
      text: '',
      icon: 'warning',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        const sendData = {
          id: editData._id,
          listIndex:listIndex
        };
        dispatch(fetchAsyncDeleteTdsPaymentListItem(sendData)).then((res) => {
          if(res?.payload?.tdsExpense?.pyInfo?.list && res?.payload?.tdsExpense?.pyInfo?.list?.length){
            setMultipleAddPaymentInfo(res?.payload?.tdsExpense?.pyInfo?.list)
          }
          else{
            setMultipleAddPaymentInfo(prevState => prevState.filter((_, i) => i !== listIndex));
          }
          addToast(prJson.success.spentAmt, { appearance: "success" });
        });
      },
    });
}
const deleteMultipleRefundListItem = (listIndex)=>{
  ConfirmationDialog({
    title: prJson.confirm.deleteRefundAmt,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      const sendData = {
        id: editData._id,
        listIndex:listIndex
      };
      dispatch(fetchAsyncDeleteTdsRefundListItem(sendData)).then((res) => {
        setMultipleAddRefundInfo(res?.payload?.tdsExpense?.rfdInfo?.list)
        addToast(prJson.success.deleteRefund, { appearance: "success" });
      });
    },
  });
}

const handleResourceNumber = (newValue)=>{
  const value = newValue;
  setSetResourcePoNo(value)
  setIsResourcePoChange(true)
  
}
const isRequestedAmountMismatch = useCallback(() => {
  
 return parseFloat(tdsAmount || 0) !== parseFloat(editData?.tdsAmt || 0) 
}, [tdsAmount,editData]);


const isSendRequest = useCallback(() => {
  const isPending = paymentStatus === 0;
  return ( isRequestedAmountMismatch() || isPending) ;
}, [paymentStatus,isRequestedAmountMismatch]);


const handleSelectTab = (k) => {
  setActiveTab(k);
};

const handleToggleRefundApplicable = () => {
  setIsRefund(!isRefund)
  if(!multipleAddRefundInfo?.length){
    setMultipleAddRefundInfo([""])
  }
};  

const hasAccess = useCallback(() => {
  return (role === "Admin" || role === "Manager" || role === 'Accountant') && paymentStatus === 1;
}, [role, paymentStatus]);

const handleAddAmount = (amt)=>{
  const parsedAmount = parseFloat(amt);
  if (!isNaN(parsedAmount)) {
    setRoundOfAmount(parsedAmount)
  }
}

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={tdsOpen}
        onClose={closeModelForm}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className=" expense-modal-header">
              TDS - <span className="header-pr">{generatedNum}</span>
            </ModalHeader>
            {/* <p>Tax Deducted at Source (TDS)</p> */}
            <ModalCloseButton />
          </div>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <ModalBody>
              <Form className="addForm" onSubmit={formik.handleSubmit}>
                <div className="form-card">
                  <h5 className="mt-0">Purchase Order Details</h5>
                  <Row className="mt-2">
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order Number <span className="span-star">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="No"
                          value={generatedNum && generatedNum}
                          disabled
                        />
                      </Box>
                    </Col>

                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order - Month <span className="span-star">*</span>
                        </Form.Label>
                        <Box>
                          <DatePicker
                            className={`monthDate ${
                              isBlink ? "month_blink active" : ""
                            }`}
                            dateFormat="MM-yyyy"
                            showMonthYearPicker
                            name="orderMonth"
                            onChange={(e) => {
                              const dateTime = moment(e).format("yyyy-MM");
                              setGetPoMonth(dateTime);
                            }}
                            disabled={isEdit}
                            // defaultValue={new Date()}
                            selected={
                              getPoMonth ? new Date(moment(getPoMonth)) : ""
                            }
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </Box>
                      </Box>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order Date <span className="span-star">*</span>
                        </Form.Label>
                        <Box>
                          <DatePicker
                            name="orderDate"
                            className={`monthDate ${
                              isBlink ? "date_blink active" : ""
                            }`}
                            dateFormat="dd-MMM-yyyy"
                            // disabled={isEdit}
                            onChange={(date) => {
                              setSelectedDate(date);
                            }}
                            selected={selectedDate}
                            minDate={startOfMonth}
                            maxDate={endOfMonth}
                            showMonthDropdown={false}
                            showYearDropdown={false}
                            dropdownMode="select"
                          />
                        </Box>
                      </Box>
                    </Col>
                    <Col className="mb-0">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Reference <span className="span-star">(PO/PR)</span>
                        </Form.Label>

                        <ClientProjectSelect
                          options={poNoResource}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) =>
                            handleResourceNumber(newValue)
                          }
                          isSearchable
                          value={setResourcePoNo}
                          defaultValue={setResourcePoNo}
                          role={role}
                        />
                      </Box>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Resource Name <span className="span-star">*</span>
                        </Form.Label>

                        <ClientProjectSelect
                          options={resourceOption}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => {
                            setResourceValue(newValue);
                          }}
                          isSearchable
                          defaultValue={resourceValue}
                          role={role}
                        />
                      </Box>
                      {errors?.resourceValue && !resourceValue && (
                        <p className="form_error">{errors?.resourceValue}</p>
                      )}
                    </Col>
                    <Col>
                      <PanNumberField
                        panNumber={panNumber}
                        handlePanNumber={(pan) => setPanNumber(pan)}
                        totalPayAmount={totalPayAmountByPanNumber}
                        role={role}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Remarks </Form.Label>

                        <Form.Control
                          as="textarea"
                          rows={2}
                          name="remarks"
                          placeholder="Type Here..."
                          value={remarksValue}
                          // defaultValue={remarksValue}
                          onChange={(e) => handleRemarksChange(e)}
                          isInvalid={!!errors?.remarks}
                        />
                      </Box>
                      <p className="form_error">{errors?.remarks}</p>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Total Amount</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <span className="rupee-symbol">₹</span>{" "}
                          </InputGroup.Text>

                          <CurrencyFormat
                            customInput={Form.Control}
                            type="text"
                            placeholder="Total Amount "
                            onValueChange={(e) => {
                              setAmountTotal(e.value);
                            }}
                            name="Total Amount "
                            value={amountTotal || ""}
                            thousandSeparator={true}
                            // prefix={"$"}

                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </InputGroup>
                      </Box>
                    </Col>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>TDS Percent</Form.Label>
                        <InputGroup className="input-group">
                          <Form.Control
                            type="number"
                            placeholder="TDS Percent"
                            defaultValue={tdsPercent}
                            disabled={editPercentNum}
                            onChange={(e) => setTdsPercent(e.target.value)}
                          />
                          <InputGroup.Text>
                            {editPercentNum ? (
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/650/650143.png"
                                alt="edit"
                                className="edit-button"
                                onClick={handleEditTDSPercentange}
                              />
                            ) : (
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/8832/8832108.png"
                                alt="edit"
                                className="edit-button"
                                onClick={() => setEditPercentNum(true)}
                              />
                            )}
                          </InputGroup.Text>
                        </InputGroup>
                      </Box>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>TDS Amount</Form.Label>

                        <InputGroup>
                          <InputGroup.Text>
                            <span className="rupee-symbol">₹</span>{" "}
                          </InputGroup.Text>

                          <CurrencyFormat
                            customInput={Form.Control}
                            type="text"
                            onValueChange={(e) => {
                              setTdsAmount(e.value);
                            }}
                            name="TDS Amount "
                            value={
                              tdsAmount
                                ? Number(tdsAmount).toFixed(2)
                                : Number(0).toFixed(2)
                            }
                            thousandSeparator={true}
                            decimalScale={2}
                            disabled={editTDSAmount}
                            fixedDecimalScale={true}
                          />
                          <InputGroup.Text>
                            {editTDSAmount ? (
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/650/650143.png"
                                alt="edit"
                                className="edit-button"
                                onClick={handleEditTDS}
                              />
                            ) : (
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/8832/8832108.png"
                                alt="edit"
                                className="edit-button"
                                onClick={handleEditSubmit}
                              />
                            )}
                          </InputGroup.Text>
                        </InputGroup>
                      </Box>
                    </Col>
                    <Col></Col>
                  </Row>
                </div>

                <div className="form-card mt-3">
                  <h5>Payment Information</h5>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Requested Amount <span className="span-star">*</span>
                        </Form.Label>
                        <InputGroup className="input-group">
                          <InputGroup.Text>
                            <span className="rupee-symbol">₹</span>{" "}
                          </InputGroup.Text>

                          <CurrencyFormat
                            customInput={Form.Control}
                            type="text"
                            disabled
                            name="approvalAmount"
                            placeholder="Requested Amount"
                            value={approvalAmount || ""}
                            onValueChange={(e) => {
                              setApprovalAmount(e.value);
                            }}
                            isInvalid={
                              (remainingAmount < 0 &&
                                approvalAmount <= totalPaymentAmount) ||
                              (!approvalAmount && errors?.approvalAmount)
                            }
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                            // prefix={"$"}
                            decimalScale={2}
                          />
                          <InputGroup.Text className="quotation-upload">
                            {approvalAmount ? (
                              <div className="add-amoun-button">
                                <AmountPopover
                                  roundOfAmount={roundOfAmount}
                                  addAmount={(value) => {
                                    handleAddAmount(value);
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            <Tooltip
                              label="Upload Quotation"
                              fontSize="md"
                              borderRadius="2xl"
                            >
                              <div
                                disabled={!approvalAmount}
                                className="position-relative"
                                onClick={() => {
                                  approvalAmount &&
                                    setOpenQuotation(!openQuotation);
                                }}
                              >
                                <FaFileUpload size={20} />
                                <span className="position-absolute top-0 start-100 translate-middle badge  bg-primary text-white">
                                  {quotationData?.files ||
                                  quotationData?.remarks
                                    ? allQuotation?.length + 1
                                    : allQuotation?.length || 0}
                                </span>
                              </div>
                            </Tooltip>
                          </InputGroup.Text>
                        </InputGroup>
                      </Box>
                      {((remainingAmount < 0 &&
                        approvalAmount <= totalPaymentAmount) ||
                        !approvalAmount) && (
                        <p className="form_error">{errors?.approvalAmount}</p>
                      )}
                    </Col>
                    {paymentStatus === 1 ? (
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Approved Amount</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <span className="rupee-symbol">₹</span>{" "}
                            </InputGroup.Text>

                            <CurrencyFormat
                              customInput={Form.Control}
                              type="text"
                              disabled
                              name="totalPayAmount"
                              placeholder="Total Amount"
                              value={
                                totalPaymentAmount ? totalPaymentAmount : 0
                              }
                              thousandSeparator={true}
                              // prefix={"$"}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </InputGroup>
                        </Box>
                      </Col>
                    ) : (
                      <Col></Col>
                    )}
                  </Row>

                  {paymentStatus === 1 && (
                    <>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Net Payable Amount</Form.Label>
                            <InputGroup>
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>

                              <CurrencyFormat
                                customInput={Form.Control}
                                type="text"
                                disabled
                                name="Net Payable Amount"
                                value={remainingAmount ? remainingAmount : 0}
                                thousandSeparator={true}
                                decimalScale={2}
                                isInvalid={
                                  remainingAmount < 0 &&
                                  approvalAmount <= totalPaymentAmount
                                }
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                          {remainingAmount < 0 &&
                            approvalAmount <= totalPaymentAmount && (
                              <p className="form_error">
                                Net payable amount cannot be negative. Please
                                revise the request with an increased requested
                                amount and resubmit for approval.
                              </p>
                            )}
                        </Col>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Total Spent Amount</Form.Label>
                            <InputGroup>
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                type="text"
                                disabled
                                name="totalPayAmount"
                                placeholder="Total Amount"
                                value={totalSpentAmount}
                                
                                thousandSeparator={true}
                                // prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
                
                  <div>
                    <Tabs
                      defaultActiveKey={
                        activeTab 
                        ? activeTab 
                        :paymentStatus === 1
                        ? "spent"
                        : "Invoices" }
                      transition={false}
                      id="noanim-tab-example"
                      className="add-form-tabs expense-tabs"
                      onSelect={handleSelectTab}
                    >
                      {paymentStatus === 1 &&
                      <Tab
                        eventKey="spent"
                        title="Spent Amount"
                        className="add-form-tab mx-0"
                      >
                        <div className="form-card">
                          {paymentStatus === 1 &&
                            multipleAddPaymentInfo.map((item, index) => {
                              return (
                                <>
                                  <PaymentInfoComponent
                                    key={`payment-info-${index}`}
                                    getData={(data) => {
                                      handleUpdateMultiplePayData(data, index);
                                    }}
                                    autoCount={index}
                                    paymentData={item}
                                    editData={editData}
                                    refreshEditData={refreshEditData}
                                    isEdit={isEdit}
                                    spentAmountError={spentAmountError}
                                    remainingAmount={remainingAmount}
                                    expenseType="tds"
                                    deleteMultipleListItem={() =>
                                      deleteMultipleListItem(index)
                                    }
                                    role={role}
                                  />
                                </>
                              );
                            })}
                          <Box display="flex" alignItems="center">
                            <h5>Add Spent Amount</h5>

                            <Button
                              className="add-project mt-2 mx-1"
                              minWidth={0}
                              disabled={!remainingAmount}

                              onClick={() => {
                                handleMultiplePayInfo(
                                  multipleAddPaymentInfo.length + 1
                                );
                              }}
                            >
                              <FaPlusCircle
                                className="add-project-icon"
                                size={15}
                              />
                            </Button>
                          </Box>
                        </div>
                      </Tab>
                      }
                      
                        <Tab
                          eventKey="Invoices"
                          title={
                            <div className="d-flex ">
                              Invoices
                              {multipleInvoiceData && multipleInvoiceData?.length > 0 && <FaCheck size={12} className="tab-icon" />}
                            </div>
                          }
                          className="add-form-tab"
                        >
                          {(activeTab === 'Invoices' || paymentStatus !== 1) &&
                          <div className="form-card">
                            <Row>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Form.Label className="bill-number">
                                    Bill Number #
                                  </Form.Label>

                                  <Box>
                                    <Form.Control
                                      type="text"
                                      name="billNumber"
                                      placeholder="Bill Number"
                                      onChange={(e) => {
                                        setBillNumber(e.target.value);
                                      }}
                                      value={billNumber}
                                    />
                                  </Box>
                                </Box>
                              </Col>
                              <Col></Col>
                            </Row>
                            <div
                              className="form-card"
                              style={{ marginBottom: "0px" }}
                            >
                              <Box display="flex" alignItems="center">
                                <h5>Invoice</h5>
                                <Button
                                  className="add-project mt-1"
                                  onClick={() => {
                                    handleInvoiceChange();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                              <Box display="flex">
                                <span
                                  className=" mt-2"
                                  style={{ color: "red", fontSize: "14px" }}
                                >
                                  * File must be less then 2Mb
                                </span>
                                {multipleInvoiceData &&
                                  multipleInvoiceData?.length >= 5 && (
                                    <strong className="mx-4 mt-2">
                                      Maximum 5 allowed
                                    </strong>
                                  )}
                              </Box>
                              {multipleInvoiceData &&
                                multipleInvoiceData?.map((item, index) => {
                                  return (
                                    <InvoiceComponent
                                      key={`invoiceData-${index}`}
                                      getInvoice={(data) =>
                                        handleUpdateInvoiceData(data, index)
                                      }
                                      selectedFile={item}
                                      handleDelete={() => {
                                        handelDeleteInvoice(index);
                                      }}
                                      handleDeleteOnEdit={(key, spId) => {
                                        handleDeleteInvoiceOnEdit(key, spId);
                                      }}
                                      isEditing={isEdit}
                                      addNewInvoiceOnEdit={(file) => {
                                        addNewInvoiceOnEdit(file, index);
                                      }}
                                      submitInvRemark={(value) => {
                                        addRemarkForInvoice(value, index);
                                      }}
                                      handleAddInvoiceRemarks={(value) => {
                                        handleAddInvoiceRemarks(value, index);
                                      }}
                                      role={role}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                          }
                        </Tab>
                      
                      {(role === "Admin" || role === "Manager") && paymentStatus === 1 && (
                        <Tab
                          eventKey="excel"
                          title={
                            <div className="d-flex">
                              Excel{" "}
                              <span className="mx-1 mt-1">
                                <RiFileDownloadLine />
                              </span>
                            </div>
                          }
                          className="add-form-tab"
                        >
                          {activeTab === "excel" &&
                          <DownloadExcelFile
                            prNo={generatedNum}
                            merchantValue={resourceValue}
                            payAmount={totalPaymentAmount}
                            role={role}
                          />
                          }
                        </Tab>
                      )}
                      {(role === "Admin" || role === "Manager") && paymentStatus === 1 && (
                        <Tab
                          eventKey="refund"
                          title={
                            <div className="d-flex">
                              Refund
                              {isRefund && (
                                <FaCheck size={12} className="tab-icon" />
                              )}
                            </div>
                          }
                          disabled={!multipleAddPaymentInfo?.length}

                          className="add-form-tab"
                        >
                          {activeTab === 'refund' &&
                          <div className="form-card">
                            <Box display="flex" alignItems="center">
                              <h5>Refund Information</h5>
                              <Form.Check
                                className="mx-1 mt-2"
                                type="switch"
                                id="custom-switch"
                                checked={isRefund}
                                onChange={() => handleToggleRefundApplicable()}
                              />
                            </Box>

                            {isRefund && (
                              <Box>
                                {multipleAddRefundInfo &&
                                  multipleAddRefundInfo?.map((item, index) => {
                                    return (
                                      <RefundInfoListComponent
                                        key={`refundInfo-${index}`}
                                        getData={(data) => {
                                          handleUpdateMultipleRefundData(
                                            data,
                                            index
                                          );
                                        }}
                                        autoCount={index}
                                        paymentData={item}
                                        editData={editData}
                                        refreshEditData={refreshEditData}
                                        deleteMultipleListItem={() =>
                                          deleteMultipleRefundListItem(index)
                                        }
                                        remainingAmount={remainingAmount}
                                        refundAmountError={refundAmountError}
                                        expenseType="tds"
                                        role={role}
                                      />
                                    );
                                  })}
                              </Box>
                            )}
                            {isRefund && (
                              <Box display="flex" alignItems="center">
                                <h5>Add Refund</h5>

                                <Button
                                  className="add-project mt-2"
                                  onClick={() => {
                                    handleMultipleRefundInfo(
                                      multipleAddRefundInfo.length + 1
                                    );
                                  }}
                                  disabled={!isRefund}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                            )}
                          </div>
                          }
                        </Tab>
                      )}
                      
                     
                    </Tabs>
                  </div>
              

                {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 && (
                    <>
                      <div className="form-card">
                        <h5>Approve OR Reject Remark</h5>

                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label>Remarks</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder="Type Here..."
                                value={approveOrRejectRemarks}
                                onChange={(e) =>
                                  setApproveOrRejectRemarks(e.target.value)
                                }
                                isInvalid={
                                  !approveOrRejectRemarks &&
                                  errors?.approveOrRejectRemarks
                                }
                              />
                            </Box>
                            {!approveOrRejectRemarks && (
                              <p className="form_error">
                                {errors?.approveOrRejectRemarks}
                              </p>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                <Row className="mt-4">
                  {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 ? (
                    <ModalFooter
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      {paymentStatus !== 1 && (
                        <div className="d-flex">
                          <Button
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => {
                              handleTotalPayAmountIsApproved(formik.values);
                            }}
                            className="submit-btn me-2"
                          >
                            Approve
                          </Button>

                          <Button
                            className="submit-btn"
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => handleTotalPayAmountIsRejected()}
                            style={{ background: "#191063" }}
                          >
                            Reject
                          </Button>
                        </div>
                      )}
                    </ModalFooter>
                  ) : (
                    <ModalFooter>
                      {isSendRequest() ? (
                        <Button
                          variant="brand"
                          disabled={totalPaymentAmount === null ? true : false}
                          onClick={() => {
                            handleAmountApproveBtn(formik.values);
                          }}
                          className="submit-btn"
                        >
                          Send Request
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          className="submit-btn"
                          variant="brand"
                          style={{ background: "#191063" }}
                          onClick={() => setCompareDataModal(true)}
                        >
                          Submit
                        </Button>
                      )}
                    </ModalFooter>
                  )}
                </Row>
              </Form>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>
      {compareDataModal && comparingData && (
        <TdsDataChangeModal
          openModal={compareDataModal}
          closeModal={closeComparedDataModal}
          editData={editData}
          currentData={comparingData}
          isConfirmed={() => {
            submitUpdateData(comparingData, editData);
          }}
          type={"tds"}
          role={role}
        />
      )}
      {openQuotation && (
        <QuotationForm
          isOpen={openQuotation}
          closeModal={() => {
            handleCloseQuotation();
          }}
          requestedAmount={approvalAmount}
          handleData={(data) => handleQuotationData(data)}
          uploadedData={quotationData}
          expenseId={editData?._id || ""}
          allQuotation={allQuotation}
        />
      )}
    </>
  );
};

export default TdsAddNew;
